export default __webpack_public_path__ + "static/media/bootstrap.49fe7130.jpeg";